import { TabPanel } from '@reach/tabs';
import React__default, { useRef, useCallback } from 'react';
import Typography from '../Typography/index.js';
import { Tabs, TabList, Tab, TabPanels } from './Tabs.styles.js';

var ContentWithTabs = function ContentWithTabs(_ref) {
  var data = _ref.data,
    _ref$isVertical = _ref.isVertical,
    isVertical = _ref$isVertical === void 0 ? false : _ref$isVertical;
  var tabsRef = useRef();
  var handleChange = useCallback(function () {
    if (isVertical && tabsRef.current) {
      tabsRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [isVertical]);
  return /*#__PURE__*/React__default.createElement(Tabs, {
    ref: tabsRef,
    isVertical: isVertical,
    onChange: handleChange,
    className: "leshen-content-with-tabs-wrapper"
  }, /*#__PURE__*/React__default.createElement(TabList, {
    isVertical: isVertical,
    className: "tab-list"
  }, data.map(function (tab) {
    return /*#__PURE__*/React__default.createElement(Tab, {
      key: tab.title,
      isVertical: isVertical,
      className: "tab"
    }, /*#__PURE__*/React__default.createElement(Typography, {
      rendersAs: "span",
      variant: "feature",
      className: "title"
    }, tab.title));
  })), /*#__PURE__*/React__default.createElement(TabPanels, {
    isVertical: isVertical,
    className: "tab-panels"
  }, data.map(function (tab) {
    return /*#__PURE__*/React__default.createElement(TabPanel, {
      key: tab.title,
      className: "tab-panel"
    }, isVertical && /*#__PURE__*/React__default.createElement(Typography, {
      rendersAs: "h3",
      variant: "h4",
      className: "title"
    }, tab.title), tab.content);
  })));
};
var ContentWithTabs$1 = ContentWithTabs;

export { ContentWithTabs$1 as default };
//# sourceMappingURL=ContentWithTabs.js.map
